// extracted by mini-css-extract-plugin
var _1 = "RequestProfileWidgetAddress-moduleaddressContent__mnmET";
var _2 = "RequestProfileWidgetAddress-moduleaddressField__lfBmM";
var _3 = "RequestProfileWidgetAddress-modulecontent__C5IIp";
var _4 = "RequestProfileWidgetAddress-moduledivider__jnNqL Divider-moduleDivider__dL3Vg";
var _5 = "RequestProfileWidgetAddress-modulelabel__wKwSQ";
var _6 = "RequestProfileWidgetAddress-modulemultilineValue__j_l6s";
var _7 = "RequestProfileWidgetAddress-moduleskeleton__oy6Vr WidgetContentSkeleton-moduleWidgetContentSkeleton__eblVC";
var _8 = "RequestProfileWidgetAddress-modulevalue__MeJri";
export { _1 as "addressContent", _2 as "addressField", _3 as "content", _4 as "divider", _5 as "label", _6 as "multilineValue", _7 as "skeleton", _8 as "value" }
